<template>
  <div class="match-invite-page page">
    <Breadcrumb :type="2" />
    <!-- 主体 -->
    <div class="detail-content">
      <div class="detail-title">{{ article.articleName || '' }}</div>
      <div class="detail-date">发布日期：{{ article.releaseTime || '' }} <span class="author-source">来源: 福建通文服务&nbsp;&nbsp;www.fjtwfw.com</span></div>
      <div class="detail-hr"></div>
      <div class="article-content" v-html="article.articleContent"></div>
      <div class="detail-area"></div>
      <div class="side-content">
        <div class="side-flex">
          <div class="flex-text">上一篇：</div>
          <div
            class="flex-title"
            :class="sideArticle.before?.articleName ? 'flex-title-active' : ''"
            @click="
              handleSideArticle(
                sideArticle.before != null ? sideArticle.before.id : null
              )
            "
          >
            {{ sideArticle.before?.articleName || '暂无最新' }}
          </div>
        </div>
        <div class="side-flex">
          <div class="flex-text">下一篇：</div>
          <div
            class="flex-title"
            :class="sideArticle.after?.articleName ? 'flex-title-active' : ''"
            @click="handleSideArticle(sideArticle.after?.id)"
          >
            {{ sideArticle.after?.articleName || '暂无最新' }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="listBlock">
              <div class="code-content">
                <img
                  class="img"
                  :src="
                    $globalHeader.fileUrl + '/static/fjtwfw/office_qrcode.png'
                  "
                  alt=""
                />
                <p class="code-text">
                  <strong>福建通文服务微信公众号</strong>
                </p>
                <img
                  class="img"
                  :src="$globalHeader.fileUrl + '/static/fjtwfw/qrcode.png'"
                  alt=""
                />
                <p class="code-text">
                  <strong>福建通文服务咨询微信二维码</strong>
                </p>
              </div>
            </div> -->
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/breadcrumb'
import { getArticleById, getSideArticle } from '@/api/home/home.js'
import { getNavItemByCode } from '@/api/common/common.js'
import { mapState } from 'vuex'
import { fixMedia } from '@/utils/util'
export default {
  name: 'Policy',
  components: { Breadcrumb },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: '新闻中心',
      newsList: [],
      article: {
        releaseTime: ''
      },
      pageType: '', //1 文章内容，2 文章列表
      categoryId: '',
      tabcode: '',
      seccode: '',
      subcode: '',
      currentCategory: {
        categoryName: '',
        englishName: ''
      },
      sideArticle: {
        before: null,
        after: null
      },
      id: null,
      currentIndex: 2
    }
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.isMobile // 假设 isMobile 在根 state 下
    })
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return
        //侧边栏列表
        this.tabList = res.data[0]
        if (this.tabList.list) {
          //拿下一级
          this.currentCategory = this.tabList.list[0]
        } else {
          this.currentCategory = this.tabList[0]
        }

        console.log('this.tabList', this.tabList)
      })
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == 'string') {
        this.$router.push('/' + data)
      }
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.article = res.data
        this.article.articleContent = fixMedia(res.data.articleContent)
        
        // 动态设置页面meta信息
        this.setPageMeta()
      })
    },
    
    // 设置页面meta信息
    setPageMeta() {
      if (!this.article) return
      
      const articleTitle = this.article.articleName || ''
      const categoryName = this.currentCategory.categoryName || '新闻中心'
      const companyName = '福建通文产业服务有限公司'
      
      // 提取文章核心词（从全文中提取）
      const coreWords = this.extractCoreWords()
      
      // 生成文章摘要
      const summary = this.generateSummary(this.article.articleContent || '')
      
      // 设置页面标题
      document.title = `${articleTitle}—${categoryName}—${companyName}`
      
      // 设置meta标签
      const keywords = `${companyName},${categoryName},${coreWords},产教融合,高质量就业服务`
      const description = `${companyName}（通文服务）${summary}。围绕政府、高校、企业、人才，持续提供园区运营、产教融合、技能提升等高质量就业服务，赋能产业发展。`
      
      const keywordsMeta = document.querySelector('meta[name="keywords"]')
      const descriptionMeta = document.querySelector('meta[name="description"]')
      
      if (keywordsMeta) {
        keywordsMeta.setAttribute('content', keywords)
      }
      if (descriptionMeta) {
        descriptionMeta.setAttribute('content', description)
      }
    },
    
    // 提取文章核心词（从全文中提取）
    extractCoreWords() {
      const content = this.article.articleContent || ''
      const title = this.article.articleName || ''
      // 合并标题和内容，去除HTML标签
      const fullText = (title + ' ' + content).replace(/<[^>]+>/g, '').replace(/\s+/g, ' ')
      
      // 简单实现：去除常见虚词，统计词频，取前5个词
      const stopWords = ['的', '了', '是', '在', '我', '有', '和', '就', '不', '人', '都', '一', '一个', '上', '也', '很', '到', '说', '要', '去', '你', '会', '着', '没有', '看', '好', '自己', '这']
      const words = fullText.split(/[^一-龥a-zA-Z0-9]+/).filter(word => word && !stopWords.includes(word) && word.length > 1)
      
      // 统计词频
      const wordFrequency = {}
      words.forEach(word => {
        wordFrequency[word] = (wordFrequency[word] || 0) + 1
      })
      
      // 按词频排序，取前5个
      const sortedWords = Object.keys(wordFrequency).sort((a, b) => wordFrequency[b] - wordFrequency[a])
      return sortedWords.slice(0, 5).join(',')
    },
    
    // 生成文章摘要
    generateSummary(content) {
      // 去除HTML标签，截取前60-80字
      const plainText = content.replace(/<[^>]+>/g, '').replace(/\s+/g, ' ')
      const length = Math.min(80, Math.max(60, plainText.length))
      return plainText.substring(0, length) + (plainText.length > length ? '...' : '')
    },
    // 查询上一篇文章和下一篇文章
    queryideArticle(id) {
      let params = {
        id: id,
        categoryCode: this.categoryId
      }
      getSideArticle(params).then((res) => {
        if (!res.data) return
        this.sideArticle = res.data
      })
    },
    handleSideArticle(id) {
      if (id == null) {
        return
      }
      let url =
        '/articleDetail?categoryId=' +
        this.categoryId +
        '&linkType=' +
        this.pageType +
        '&tabcode=' +
        this.tabcode +
        '&seccode=' +
        this.seccode +
        '&id=' +
        id
      window.location.href = url
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log('item', this.currentCategory)
      console.log('tab', tab)
      let url =
        '?categoryId=' +
        item.categoryCode +
        '&linkType=' +
        item.linkType +
        '&tabcode=' +
        this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab //二级标题
      this.categoryId = item.categoryCode //当前标题
      this.subcode = item.categoryCode //三级标题
      this.pageType = item.linkType
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(
          (item) => item.categoryCode == this.categoryId
        )

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode
          this.subcode = targetItem.list[0].categoryCode
          this.categoryId = targetItem.list[0].categoryCode
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl)
        url = '/article' + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = '/singleImage' + url
      }
      if (item.linkType == 3) {
        console.log(item.linkType)
      }
      if (item.linkType == 4) {
        console.log(item.linkType)
      }
      if (item.linkType == 5) {
        console.log(item.linkType)
      }
      this.$router.push({
        path: url
      })
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType
    this.id = this.$route.query?.id
    this.categoryId = this.$route.query?.categoryId
    this.tabcode = this.$route.query?.tabcode
    if (this.tabcode == 103) {
      this.currentIndex = 2
    }
    if (this.tabcode == 104) {
      this.currentIndex = 3
    }
    this.seccode = this.$route.query?.seccode
    this.fetchData()
    this.getArticleData(this.id)
    this.queryideArticle(this.id)
  }
}
</script>

<style lang="scss" scoped>
.match-invite-page {
  display: flex;
  flex-direction: column;
  .detail-content {
    display: flex;
    flex-direction: column;
    width: 1340px;
    margin: 64px auto 120px;
    .side-content {
      display: flex;
      flex-direction: column;
      .side-flex {
        min-height: 22px;
        line-height: 22px;
        display: flex;
        flex-direction: row;
        font-size: 16px;
        .flex-title {
          color: #111;
          flex: 1;
        }
        .flex-title-active {
          color: #005bac;
          cursor: pointer;
        }
        .flex-text {
          color: 111;
        }
      }
      .side-flex:last-child {
        margin-top: 16px;
      }
    }
    .detail-area {
      background: #f9fafb;
      height: 38px;
      margin: 42px 0 10px;
    }
    .article-content {
      color: #111;
      font-size: 20px;
      line-height: 44px;
      word-break: break-all;
    }
    .detail-hr {
      border-top: 1px solid #e6e6e6;
      margin: 36px 0 42px;
    }
    .detail-date {
      text-align: center;
      margin-top: 24px;
      color: #5c5c5c;
      font-size: 16px;
      height: 22px;
      line-height: 22px;
      .author-source {
        margin-left: 20px;
        font-size: 16px;
        .source-link {
          color: #005bac;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .detail-title {
      line-height: 27px;
      color: #111;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }
  }
}

// 手机端css
.mobile-content {
  .match-invite-page {
    .detail-content {
      width: 345px;
      margin: 20px auto 60px;
      .side-content {
        .side-flex {
          font-size: 13px;
        }
        .side-flex:last-child {
          margin-top: 10px;
        }
      }
      .detail-area {
        height: 19px;
        margin: 21px 0 10px;
      }
      .article-content {
        font-size: 14px;
        line-height: 22px;
        img {
          width: 100%;
        }
      }
      .detail-hr {
        margin: 18px 0 21px;
      }
      .detail-date {
        margin-top: 12px;
        font-size: 12px;
        line-height: 18px;
        height: 18px;
        .author-source {
          margin-left: 12px;
          font-size: 12px;
          .source-link {
            color: #005bac;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
      .detail-title {
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
